import { Card, type CardProps, mergeSxProps } from "@src/appV2/redesign/system/ui-components";

import { isRebrandingEnabled } from "../../system/ui-theme";

interface ShiftCardWrapperProps extends CardProps {
  isUrgent?: boolean;
  isBundle?: boolean;
  isDouble?: boolean;
  isForYouShift?: boolean;
}

export function ShiftCardWrapper(props: ShiftCardWrapperProps) {
  const {
    isUrgent = false,
    isBundle = false,
    isDouble = false,
    isForYouShift = false,
    variant = "quaternary",
    outlined = true,
    sx,
    ...restProps
  } = props;

  return (
    <Card
      variant={variant}
      outlined={isUrgent || isBundle || isDouble || isForYouShift || outlined}
      sx={mergeSxProps(
        (theme) => ({
          minHeight: theme.size?.shiftCard.minHeight,
          borderColor: (theme) => {
            if (isUrgent) {
              return theme.palette.shift?.urgent.border;
            }
            if (isBundle) {
              return theme.palette.shift?.bundle?.border;
            }
            if (isDouble) {
              return theme.palette.shift?.double?.border;
            }
            return undefined;
          },
          ...((isUrgent || isBundle || isDouble || isForYouShift) &&
            isRebrandingEnabled() && {
              borderWidth: theme.borderWidth.thick,
            }),
          ...(isForYouShift &&
            !isDouble && {
              background: (theme) => theme.palette?.shift?.forYou.background,
              border: (theme) => theme.palette.shift?.forYou.border,
            }),
        }),
        sx
      )}
      {...restProps}
    />
  );
}
